import { render, staticRenderFns } from "./LexonSelectComponent.vue?vue&type=template&id=4a1a036e&scoped=true&lang=pug"
import script from "./LexonSelectComponent.vue?vue&type=script&lang=ts"
export * from "./LexonSelectComponent.vue?vue&type=script&lang=ts"
import style0 from "./LexonSelectComponent.vue?vue&type=style&index=0&id=4a1a036e&lang=scss&scoped=true"
import style1 from "./LexonSelectComponent.vue?vue&type=style&index=1&id=4a1a036e&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1a036e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a1a036e')) {
      api.createRecord('4a1a036e', component.options)
    } else {
      api.reload('4a1a036e', component.options)
    }
    module.hot.accept("./LexonSelectComponent.vue?vue&type=template&id=4a1a036e&scoped=true&lang=pug", function () {
      api.rerender('4a1a036e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/fields/LexonSelect/LexonSelectComponent.vue"
export default component.exports